import type { AuthExchangeResponse, CurrentUserResponse } from '../auth/types'
import { apiGet, apiPost } from './client'

const exchangeRequests = new Map<string, Promise<AuthExchangeResponse>>()

export function exchangeSsoAssertion(assertion: string): Promise<AuthExchangeResponse> {
  const normalizedAssertion = assertion.trim()
  if (!normalizedAssertion) {
    return Promise.reject(new Error('SSO assertion이 없습니다.'))
  }

  const existing = exchangeRequests.get(normalizedAssertion)
  if (existing) return existing

  const request = apiPost<AuthExchangeResponse>(
    '/api/auth/sso/exchange',
    { assertion: normalizedAssertion },
    { auth: false, clearSessionOnUnauthorized: false },
  )

  exchangeRequests.set(normalizedAssertion, request)
  request.then(
    () => {
      if (exchangeRequests.get(normalizedAssertion) === request) {
        exchangeRequests.delete(normalizedAssertion)
      }
    },
    () => {
      if (exchangeRequests.get(normalizedAssertion) === request) {
        exchangeRequests.delete(normalizedAssertion)
      }
    },
  )

  return request
}

export function getCurrentUser(): Promise<CurrentUserResponse> {
  return apiGet<CurrentUserResponse>('/api/me')
}
